module.exports = __webpack_public_path__ + "static/media/litmus.c731b180.png";